import React, { FC } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import featurePosts, { formatFeatureDate, tagColors } from './FeaturePosts';
import { SEO } from 'components/seo/SEO';
import { articleJsonLd, breadcrumbJsonLd } from 'components/seo/organizationSchema';
// Shares the blog post styles so feature pages read like blog posts
import '../blog/Blog.css';
import './Features.css';

export const FeaturePostPage: FC = () => {
  const { id } = useParams<{ id: string }>();
  const post = featurePosts.find((p) => p.id === id);

  if (!post) return <div className="blog-post-not-found">Feature not found.</div>;

  const path = `/features/${post.id}`;
  const color = tagColors[post.tag];

  return (
    <article className="blog-post-container">
      <SEO
        title={`${post.title} — Toastie Health`}
        description={post.subtitle}
        path={path}
        jsonLd={[
          articleJsonLd({ title: post.title, description: post.subtitle, path, datePublished: post.date }),
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Features', path: '/features' },
            { name: post.title, path },
          ]),
        ]}
      />
      <nav className="features-breadcrumb" aria-label="Breadcrumb">
        <Link to="/features">← All Features</Link>
      </nav>
      <header className="blog-post-header">
        <div className="blog-post-tag" style={{ backgroundColor: `var(--${color}200)`, color: `var(--${color}800)` }}>
          {post.tag}
        </div>
        <h1 className="blog-post-title">{post.title}</h1>
        <h5 className="blog-post-subtitle">{post.subtitle}</h5>
        <p className="blog-post-date">
          <time dateTime={post.date}>{formatFeatureDate(post.date)}</time> &nbsp; • &nbsp; {post.readTime} read
        </p>
      </header>
      <img
        src={post.image}
        alt={post.screenshot ? `${post.title} in the Toastie app` : ''}
        className={post.screenshot ? 'feature-post-screenshot' : 'blog-post-image'}
      />
      <div className="blog-post-body">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{post.content}</ReactMarkdown>
      </div>
    </article>
  );
};
